import PropTypes from "prop-types";

// Components
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";

// MUI
import { Grid, Stack, Tooltip, Typography } from "@mui/material";

// Icons
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";

export default function AdvancedSelectLabel(props) {
	const {
		label = "Reference",
		tooltip = null,
		data = [],
		disabledOptions = [],
		selected = null,
		showBy = "_id",
		selectBy = "_id",
		placeholder = "Select...",
		loading = false,
		readOnly = false,
		sxSelectContainer = { minWidth: "160px" },
		containerWidth = "auto",
		onChangeSelection = () => {},
	} = props;
	return (
		<Grid container direction="row" columnSpacing={2.5} alignItems={"center"} width={containerWidth}>
			{Boolean(label) && (
				<Grid item>
					<Typography className="draw-label" mr={0.2}>
						{label}
					</Typography>
				</Grid>
			)}
			<Grid item>
				<Stack direction={"row"} alignContent={"center"} alignItems={"center"} sx={sxSelectContainer}>
					<SmartSelector
						selectDefault
						selectBy={selectBy}
						showBy={showBy}
						options={data}
						disabledOptions={disabledOptions}
						selected={selected}
						inputProps={{
							placeholder,
						}}
						listBoxProps={{
							sx: { maxHeight: "220px" },
						}}
						disabled={readOnly}
						loading={loading}
						onChangeAction={(value) => onChangeSelection?.(value)}
					/>

					{Boolean(tooltip) && (
						<Stack ml={1} sx={{ color: "var(--neutral-gray)" }}>
							<Tooltip title={tooltip}>
								<InfoRoundedIcon fontSize={"small"} />
							</Tooltip>
						</Stack>
					)}
				</Stack>
			</Grid>
		</Grid>
	);
}
AdvancedSelectLabel.propTypes = {
	label: PropTypes.string,
	tooltip: PropTypes.string,
	data: PropTypes.array,
	disabledOptions: PropTypes.array,
	selected: PropTypes.object,
	showBy: PropTypes.string,
	selectBy: PropTypes.string,
	placeholder: PropTypes.string,
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	sxSelectContainer: PropTypes.object,
	containerWidth: PropTypes.string,
	onChangeSelection: PropTypes.func,
};
